var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { unpackOutageEvent, unpackPartnerCheck } from "./public.mapper";
var outageEventURL = "/public/outage_feed";
var captchaURL = "/verify_grecaptcha";
var checkPartnerURL = function (id) { return "/partners/".concat(id, "/data/public"); };
var instatusURL = "/status/components";
var triggerEmailVerificationURL = "/public/generate_otp";
var verifyEmailURL = function (_a) {
    var otp = _a.otp;
    return "/public/verify_otp/".concat(otp);
};
export var outageEvent = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(outageEventURL)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, unpackOutageEvent(data)];
        }
    });
}); };
export var verifyCaptcha = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(captchaURL, { token: token })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var triggerEmailVerification = function (_a) {
    var email = _a.email, action = _a.action;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(triggerEmailVerificationURL, { email: email, action: action })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var verifyEmail = function (_a) {
    var email = _a.email, otp = _a.otp, action = _a.action;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(verifyEmailURL({ otp: otp }), { email: email, action: action })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var checkPartner = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(checkPartnerURL(id))];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, unpackPartnerCheck(data)];
        }
    });
}); };
export var checkStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(instatusURL)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
//# sourceMappingURL=data:application/json;base64,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